import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api/client';

export default function FreeSpinCountdown({ onClaimed }) {
  const [status, setStatus] = useState(null);
  const [countdown, setCountdown] = useState('');
  const [claiming, setClaiming] = useState(false);

  const fetchStatus = useCallback(() => {
    api.get('/spins/free-spin-status').then(setStatus).catch(() => {});
  }, []);

  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  useEffect(() => {
    if (!status || status.canClaim) return;
    const updateCountdown = () => {
      const diff = new Date(status.next_free_spin_at).getTime() - Date.now();
      if (diff <= 0) { setStatus(prev => ({ ...prev, canClaim: true })); setCountdown(''); return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor(diff / 3600000) % 24;
      const m = Math.floor(diff / 60000) % 60;
      const s = Math.floor(diff / 1000) % 60;
      setCountdown(d > 0 ? `${d}d ${h}h ${m}m ${s}s` : `${h}h ${m}m ${s}s`);
    };
    updateCountdown();
    const iv = setInterval(updateCountdown, 1000);
    return () => clearInterval(iv);
  }, [status]);

  const handleClaim = async () => {
    setClaiming(true);
    try {
      await api.post('/spins/claim-free-spin');
      fetchStatus();
      if (onClaimed) onClaimed();
    } catch { /* ignore */ } finally { setClaiming(false); }
  };

  if (!status) return null;

  const spins        = status.spins_to_award || 1;
  const streakBroken = status.streak_broken;

  // Streak expiry countdown — how long until 48h window closes
  let streakExpiresIn = null;
  if (!status.canClaim && status.streak_expires_at && (status.current_streak || 0) > 0) {
    const diff = new Date(status.streak_expires_at).getTime() - Date.now();
    if (diff > 0 && diff < 24 * 60 * 60 * 1000) {
      const h = Math.floor(diff / 3600000);
      const m = Math.floor(diff / 60000) % 60;
      streakExpiresIn = h > 0 ? `${h}h ${m}m` : `${m}m`;
    }
  }

  return (
    <div className="card" style={{ marginBottom: 16, padding: '12px 14px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

        {/* Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {status.canClaim ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: streakBroken ? 'var(--warning)' : 'var(--success)', lineHeight: 1.2 }}>
                  🌿 Sesh Time! {spins > 1 ? `×${spins}` : ''}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
                  {streakBroken
                    ? 'Streak lost — back to 1 spin'
                    : spins === 1 ? 'Daily free toke ready' : `Day ${spins} bonus — ${spins} free spins`}
                </div>
              </div>
              <button
                className="btn-success"
                onClick={handleClaim}
                disabled={claiming}
                style={{ padding: '6px 14px', fontSize: 13, marginLeft: 'auto', whiteSpace: 'nowrap', flexShrink: 0 }}
              >
                {claiming ? '...' : `Claim ${spins}`}
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.2 }}>Next free toke in</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--accent)', fontFamily: 'monospace', lineHeight: 1.3 }}>
                  {countdown}
                </div>
                {streakExpiresIn && (
                  <div style={{ fontSize: 10, color: 'var(--warning)', marginTop: 2 }}>
                    ⚠️ Streak expires in {streakExpiresIn}
                  </div>
                )}
              </div>
              <div style={{
                marginLeft: 'auto', flexShrink: 0,
                background: 'rgba(56,161,105,0.1)',
                border: '1px solid rgba(56,161,105,0.25)',
                borderRadius: 'var(--radius-sm)',
                padding: '4px 10px',
                fontSize: 11, color: 'var(--success)', fontWeight: 600,
                whiteSpace: 'nowrap',
              }}>
                Tomorrow: {spins} spin{spins > 1 ? 's' : ''}
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
